document.addEventListener("DOMContentLoaded", function () {

  const podcastPlayer = document.querySelector('.podcastPlayer');

  if (podcastPlayer) {
    const playButtons = document.querySelectorAll('.podcastCard__footer .textLink--listen');
    const podcastPlayerClose = document.querySelector('.podcastPlayer__close');

    const podcastPlayerContent = document.querySelector('.podcastPlayer__content');

    playButtons.forEach(function (playButton) {
      if (podcastPlayer.querySelector('script')) {
        podcastPlayer.querySelector('script').remove();
      }

      playButton.addEventListener('click', function () {
        let podcastPlatform = playButton.getAttribute('data-platform');
        let podcastSrc = playButton.getAttribute('data-embed-src');
        if (podcastPlatform === 'spotify') {
          podcastPlayer.setAttribute('data-platform', 'spotify');
          var podcastEmbedCode = `<iframe style="border-radius:12px" src="${podcastSrc}" width="100%" height="232" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>`;
        } else if (podcastPlatform === 'apple') {
          podcastPlayer.setAttribute('data-platform', 'apple');
          var podcastEmbedCode = `<iframe allow="autoplay *; encrypted-media *;" frameborder="0" height="450px" style="width:100%;max-width:660px;overflow:hidden;background:transparent;" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation-by-user-activation" src="${podcastSrc}"></iframe>`;
        } else {
          podcastPlayer.setAttribute('data-platform', 'soundcloud');
          var podcastEmbedCode = `<iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="${podcastSrc}"></iframe>`;
        }
        podcastPlayerContent.innerHTML = podcastEmbedCode;
        podcastPlayer.classList.add('active');

      });
    });

    podcastPlayerClose.addEventListener('click', function () {
      podcastPlayerContent.innerHTML = '';
      podcastPlayer.classList.remove('active');
      podcastPlayer.removeAttribute('data-platform');
    });

  }

});
